import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';
// 		   'home' => 0,
//         'day' => 1,
//         'alumni' => 2,
//         'orientation' => 3,
//         'international' => 4,
//         'company' => 5,
//         'data' => 6

const actualidad = {
	state: {
		noticias: [],
		eventos: [],
		recursos: []
	},
	getters: {
		getNoticias: (state) => (position) => {
			return state.noticias.filter(function (noticia){
				return noticia.position.includes(position.toString());
			})
		},
		getEventos: (state) => (position) => {
			return state.eventos.filter(function (evento){
				return evento.position.includes(position.toString());
			})
		},
		getFullNoticias: state => state.noticias,
		getFullEventos: state => state.eventos,
		getRecursosOrientacion: state => state.recursos.filter(e => e.position.includes("3")),

		getNoticiasDia: state => state.noticias.filter(e => e.position.includes("1")),
		getEventosDia: state => state.eventos.filter(e => e.position.includes("1")),

		getRecursosInternacional: state => state.recursos.filter(e => e.position.includes("4")),
		getAtributes: (state) => (request) => {
			let elements;

			if(request.type != "-1"){
				elements = state[request.type];
			
			}else{
				elements = state.noticias.concat(state.eventos);
			
			}

		
			let data = {
				area: [],
				categoria: [],
				titulos: [],
				tags: []
			}
			
			
			
			if(request.position != "-1" && !!elements){
				elements  = elements.filter( e => e.position.includes(String(request.position)));
			}

			console.log(elements);

			elements.forEach(e => {

				Object.entries(data).forEach((d) => {
					if (!!e[d[0]]) {
						e[d[0]].forEach(value => {
							if (!data[d[0]].some(v => JSON.stringify(v) == JSON.stringify(value))) {
								data[d[0]].push(value)
							}
						})
					}
				})

			});

			

			return data;



		},
		getNoticiasFiltradas: state => {

			return (filtro) => {

				let searchIn = ['titulo', 'entradilla']

				let noticias = state.noticias;

				let filtradas;

				if (!!noticias) {

					filtradas = noticias.filter(noticia => {

						let can = false;

						searchIn.forEach(where => {
							(noticia[where].toLowerCase().includes(filtro.search.toLowerCase())) ? can = true : '';
						});

						return (can) ? noticia : '';
					});

					filtradas = filtradas.filter(noticia => noticia.categoria.slug.includes(filtro.categoria));
				}

				return filtradas;

			}
		},
	},
	actions: {
		requestNoticias: ({ commit },) => {
			return new Promise((resolve, reject) => {

				axios.get(`api/entries/es/noticias`)
					.then(response => {
						if (!!response.data.entries) {
							commit('setNoticias', response.data.entries);
						}
						resolve(true);
					})
					.catch(error => reject(error));

			});
		},
		requestNoticia: ({ commit }, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/es/noticia/${slug}`)
					.then(response => {
						resolve(response.data);
					})
					.catch(err => reject(error));

			});
		},
		requestEventos: ({ commit },) => {
			return new Promise((resolve, reject) => {

				axios.get(`api/entries/es/eventos`)
					.then(response => {
						if (!!response.data.entries) {
							commit('setEventos', response.data.entries);
						}
						resolve(true);
					})
					.catch(error => reject(error));

			});
		},
		requestEvento: ({ commit }, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/es/evento/${slug}`)
					.then(response => {
						resolve(response.data);
					})
					.catch(err => reject(error));

			});
		},
		requestRecursos: ({ commit },) => {
			return new Promise((resolve, reject) => {

				axios.get(`api/entries/es/recursos`)
					.then(response => {
						commit('setRecursos', response.data.entries);
						resolve(true);
					})
					.catch(error => reject(error));

			});
		},
		requestRecurso: ({ commit }, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/es/recurso/${slug}`)
					.then(response => {
						resolve(response.data);
					})
					.catch(err => reject(error));

			});
		},
	},
	mutations: {
		setNoticias: (state, noticias) => {
			state.noticias = noticias;
		},
		setEventos: (state, eventos) => {
			state.eventos = eventos;
		},
		setRecursos: (state, recursos) => {
			state.recursos = recursos;
		},
	}
}

export default actualidad;



// WEBPACK FOOTER //
// ./src/store/actualidad.js